import { Avatar, Stack, Tooltip } from "@mui/material";
import { PermissionEnum } from "@rms-types/modules/permission/enum";

import { ActionableDisclosuresChip } from "./application-actionable-disclosures-chip";
import { ApplicationUnassignedDisclosuresChip } from "./application-unassigned-disclosures-chip";

import { useUserStore } from "@/hooks";

interface ApplicationStatsProps {
  actionableDisclosuresCount: number;
  unassignedDisclosuresCount: number;
  variant?: "chip" | "badge";
}

export function ApplicationStats({
  actionableDisclosuresCount,
  unassignedDisclosuresCount,
  variant = "chip",
}: ApplicationStatsProps) {
  const { hasPermission } = useUserStore();
  const hasQueueManagementAccess = hasPermission(PermissionEnum.QUEUE_MANAGEMENT_ACCESS);
  const hasReviewApplicationsAccess = hasPermission(PermissionEnum.REVIEW_APPLICATIONS_ACCESS);

  if (variant === "badge") {
    return (
      <Stack direction="row" spacing={1}>
        {!!actionableDisclosuresCount && !hasQueueManagementAccess && hasReviewApplicationsAccess && (
          <Tooltip title="Disclosures not started">
            <Avatar
              sx={{
                bgcolor: (theme) => theme.palette.orange.main,
                width: 20,
                height: 20,
                fontSize: "0.875rem",
              }}
              variant="circular"
            >
              {actionableDisclosuresCount}
            </Avatar>
          </Tooltip>
        )}

        {!!unassignedDisclosuresCount && hasQueueManagementAccess && (
          <Tooltip title="Unassigned disclosures">
            <Avatar
              sx={{
                bgcolor: (theme) => theme.palette.error.light,
                width: 20,
                height: 20,
                fontSize: "0.875rem",
              }}
              variant="circular"
            >
              {unassignedDisclosuresCount}
            </Avatar>
          </Tooltip>
        )}
      </Stack>
    );
  }

  return (
    <Stack spacing={1}>
      {/* Analysts see total items in the queue */}
      {!!actionableDisclosuresCount && !hasQueueManagementAccess && hasReviewApplicationsAccess && (
        <ActionableDisclosuresChip actionableDisclosuresCount={actionableDisclosuresCount} />
      )}

      {/* Manager can see the total items in the queue  - waiting on update of access for manager */}
      {!!unassignedDisclosuresCount && hasQueueManagementAccess && (
        <ApplicationUnassignedDisclosuresChip unassigned_disclosures={unassignedDisclosuresCount} />
      )}
    </Stack>
  );
}
